import {
  Device,
  Device_PlatformType,
  Device_Status,
} from 'APP/wsApi/wsAppApi/types/device/device_model_pb';
import { DeviceResponse } from 'APP/wsApi/wsAppApi/types/device/device_response_pb';

import {
  IUserDevices,
  IUserDevice,
  IUserDevicesItem,
  PlatformTypesEnum,
  DeviceStatus,
} from './userSettingsModel.types';

export function mapDeviceStatusResponse(deviceStatus?: Device_Status): DeviceStatus {
  if (typeof deviceStatus === 'undefined') {
    return DeviceStatus.Trusted;
  }

  const deviceStatusResponseMap: Record<Device_Status, DeviceStatus> = {
    [Device_Status.BLOCKED]: DeviceStatus.Blocked,
    [Device_Status.DELETED]: DeviceStatus.Deleted,
    [Device_Status.PENDING]: DeviceStatus.Pending,
    [Device_Status.TRUSTED]: DeviceStatus.Trusted,
    [Device_Status.UNLOCKED]: DeviceStatus.Unlocked,
  };

  return deviceStatusResponseMap[deviceStatus];
}

export function mapDeviceStatusRequest(deviceStatus: DeviceStatus): Device_Status {
  const deviceStatusRequestMap: Record<DeviceStatus, Device_Status> = {
    [DeviceStatus.Blocked]: Device_Status.BLOCKED,
    [DeviceStatus.Deleted]: Device_Status.DELETED,
    [DeviceStatus.Pending]: Device_Status.PENDING,
    [DeviceStatus.Trusted]: Device_Status.TRUSTED,
    [DeviceStatus.Unlocked]: Device_Status.UNLOCKED,
  };

  return deviceStatusRequestMap[deviceStatus];
}

export const mapUserDevice = (device: Device): IUserDevice => {
  return {
    deviceId: device.deviceId,
    platform: PlatformTypes[device.platform],
    device: device.device,
    osName: device.osName,
    osVersion: device.osVersion,
    appVersion: device.appVersion,
    status: mapDeviceStatusResponse(device.status),
    statusAt: String(device.statusAt),
  };
};

export const mapUserDevicesItem = (item: DeviceResponse): IUserDevicesItem => {
  return {
    id: String(item.id),
    device: mapUserDevice(item.device as Device),
    createdAtTs: Number(item.createdAtTs),
    lastActivityTs: Number(item.lastActivityTs),
  };
};

export const mapUserDevices = (data: DeviceResponse[]): IUserDevices => {
  return data.map((item) => {
    return mapUserDevicesItem(item);
  });
};

export const PlatformTypes = {
  [Device_PlatformType.WEB]: PlatformTypesEnum.WEB,
  [Device_PlatformType.DESKTOP]: PlatformTypesEnum.DESKTOP,
  [Device_PlatformType.HUAWEI]: PlatformTypesEnum.HUAWEI,
  [Device_PlatformType.ANDROID]: PlatformTypesEnum.ANDROID,
  [Device_PlatformType.IOS]: PlatformTypesEnum.IOS,
  [Device_PlatformType.OTHER]: PlatformTypesEnum.OTHER,
};
